/** @jsx jsx */
import React from 'react';
import { Column } from 'react-table';
import { css, jsx } from '@emotion/core';
import { useHistory } from 'react-router-dom';
import DataTable from 'components/organismos/DataTable/DataTable';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import EmploymentDomain from 'domain/employment';
import ConfirmModal from 'components/organismos/ConfirmModal';
import { SubActionButton } from 'components/atoms/Button';
import FormContentFilter from 'components/atoms/Form/FormContentFilter';
import ApplyDateFilter from './ApplyDateFilter';
import ButtonNavigation from './ButtonNavigation';
import { useEmploymentDelete } from './hooks';
import FormContents from 'components/atoms/Form/FormContents';
import FormPadding from "components/atoms/Form/FormPadding";
import FormHeader from 'components/templates/FormHeader';

const styles = {
  filterSearch: css({
    marginLeft: '37px',
    // marginBottom: '10px'
  }),
  note: css({
    color: '#ED5D5D',
    marginLeft: '76px',
    fontSize: '12px',
    paddingTop:'8px',
  }),
  formContentFilter: css({
    maxWidth: '700px',
    padding: '8px 0px',
    // paddingTop:'8px',
    paddingBottom: 0,
  }),
  columnOne: css({
    justifyContent: 'center',
    width: '140px',
    margin: '0 auto'
  }, css`
    button{
      white-space:nowrap;
    }
  `)
}

const EmploymentListTable: React.FC<{
  employmentList: Array<EmploymentDomain>;
  fetchData: () => Promise<void>;
  allEmployment: boolean;
  toggleAllEmployment: () => void;
  applyDate: Date;
  setApplyDate: (arg: Date) => void;
}> = ({
  employmentList, fetchData, allEmployment, toggleAllEmployment, applyDate, setApplyDate,
}) => {
    const history = useHistory();
    const {
      // delEmployment,
      setDelEmployment,
      isOpenDeleteModal,
      closeDeleteModal, onSubmitDeleteEmployment,
    } = useEmploymentDelete(fetchData);

    const columns: Array<Column<EmploymentDomain>> = React.useMemo(() => [
      {
        Header: () => null,
        accessor: 'employmentId',
        id: 'actionButton',
        disableSortBy: true,
        Cell: (cell: { row: { isExpanded: boolean, original: EmploymentDomain } }) => {
          return (
            <FlexBox customStyle={styles.columnOne}>
              <FlexBoxItem width='36px'>
                <SubActionButton action={0} text="編集" onClick={() => {
                  history.push(`/masterEmploymentForm/edit/2/${cell.row.original.employmentId}/${cell.row.original.applyStartDate}`);
                }} />
              </FlexBoxItem>
              <FlexBoxItem marginLeft="5px" width='36px'>
                <SubActionButton action={1} text="削除" onClick={() => setDelEmployment(cell.row.original)} />
              </FlexBoxItem>
              <FlexBoxItem marginLeft="5px">
                <SubActionButton action={2} text="コピー" onClick={() => {
                  history.push(`/masterEmploymentForm/edit/1/${cell.row.original.employmentId}/${cell.row.original.applyStartDate}`);
                }} />
              </FlexBoxItem>
            </FlexBox>
          );
        },
      },
      {
        Header: '雇用形態コード',
        accessor: 'employmentCode',
      },
      {
        Header: '雇用形態名',
        accessor: 'employmentName',
      },
      {
        Header: '運用開始年月',
        accessor: 'dispApplyDateStr',
      },
    ], [setDelEmployment, history]);

    return (
      <React.Fragment> 
        <FormHeader title="雇用形態マスタ" />
        <FormContents customStyle={css({marginTop:'60px'})}>        
            <FormPadding customStyle={css({paddingTop:'16px'})}>
              {/* <FormContentFilter customStyles={styles.formContentFilter}> */}
                <ApplyDateFilter
                  allEmployment={allEmployment}
                  toggleAllEmployment={toggleAllEmployment}
                  defaultValue={new Date()}
                  applyDate={applyDate}
                  setApplyDate={setApplyDate}
                />
                <span css={styles.note}>適用年月を指定した場合、適用年月時点で有効な雇用形態の一覧を表示します。</span>
              {/* </FormContentFilter> */}
            </FormPadding>
            <FormPadding customStyle={css({padding:'0 16px 0 8px'})}>
              <ButtonNavigation />
            </FormPadding>
            <div
              css={css` 
              table{
                table-layout: auto;
              }
              table th:nth-of-type(1) {
                width: 140px;
              }
              table th:nth-of-type(2) {
                width: 400px;
                text-align: center;
              }
              table th:nth-of-type(3) {
                width: 400px;
                text-align: center;
              }
              table th:nth-of-type(4) {
                width: 500px;
              }
              table td:nth-of-type(4){
                text-align: center;
              }
            `}
            >
              <div 
                className="table-bordered table-padding" 
                style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom:'15px' }}
              >
                <DataTable
                  columns={columns}
                  classNameParrant="border-left-right"
                  className="table-no-border-left-right"
                  data={employmentList}
                  isGlobalFilter={true}
                  // globalSearchStyle={styles.filterSearch}
                  // isHiddenPagination={true}
                />
              </div>
            </div>
          <ConfirmModal
            open={isOpenDeleteModal}
            closeHandler={closeDeleteModal}
            title="雇用形態マスタを削除"
            content="雇用形態マスタを削除します。よろしいですか？"
            submitText="削除する"
            onSubmit={onSubmitDeleteEmployment}
            items={[]}
            typeSubmit="reject"
          />

        </FormContents>
      </React.Fragment>
    );
  };

export default EmploymentListTable;
